/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_Scope_TodayInputs */

const en_us2_swap_scope_today = /** @type {(inputs: Swap_Scope_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Just today`)
};

const pt_br2_swap_scope_today = /** @type {(inputs: Swap_Scope_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Somente hoje`)
};

const es_419_swap_scope_today = /** @type {(inputs: Swap_Scope_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo hoy`)
};

const pt_pt2_swap_scope_today = /** @type {(inputs: Swap_Scope_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só hoje`)
};

const fr_fr2_swap_scope_today = /** @type {(inputs: Swap_Scope_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juste aujourd'hui`)
};

const de_de2_swap_scope_today = /** @type {(inputs: Swap_Scope_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur heute`)
};

const it_it2_swap_scope_today = /** @type {(inputs: Swap_Scope_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo oggi`)
};

/**
* | output |
* | --- |
* | "Just today" |
*
* @param {Swap_Scope_TodayInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_scope_today = /** @type {((inputs?: Swap_Scope_TodayInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Scope_TodayInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_scope_today(inputs)
	if (locale === "es-419") return es_419_swap_scope_today(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_scope_today(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_scope_today(inputs)
	if (locale === "de-DE") return de_de2_swap_scope_today(inputs)
	if (locale === "it-IT") return it_it2_swap_scope_today(inputs)
	return en_us2_swap_scope_today(inputs)
});
export { swap_scope_today as "swap.scope_today" }